import React, { useState, useContext, useEffect } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { HelmetDatoCms } from 'gatsby-source-datocms';
import GlobalStyle from '../styles/GlobalStyle';
import { Wrapper } from './ui';
import LocalBusinessSchema from './LocalBusinessSchema';
import Header from './Header';
import Cart from './Cart';
import ReviewsCarousel from './ReviewsCarousel';
import Footer from './Footer';
import { StoreContext } from '../context/StoreContext';

const Layout = ({ seo, noIndex, cartCrossSellProducts, children }) => {
  const {
    datoCmsSite: { faviconMetaTags },
  } = useStaticQuery(graphql`
    query LayoutQuery {
      datoCmsSite {
        faviconMetaTags {
          ...GatsbyDatoCmsFaviconMetaTags
        }
      }
    }
  `);

  const [isNavOpen, setNavOpen] = useState(false);

  const {
    isOverlayActive,
    setOverlayActive,
    isCartOpen,
    toggleCartOpen,
    isSearchOpen,
    setSearchOpen,
  } = useContext(StoreContext);

  useEffect(() => {
    setOverlayActive(isCartOpen || isSearchOpen);
  }, [setOverlayActive, isCartOpen, isSearchOpen]);

  useEffect(() => {
    if (window.klReviewsObject) {
      window.klReviewsObject.renderWidgets();
    } else {
      setTimeout(() => {
        const klaviyoScript = document.querySelector(
          'script[src*="klaviyo.js"]',
        );
        klaviyoScript &&
          klaviyoScript.addEventListener('load', () => {
            window.klReviewsObject.renderWidgets();
          });
      }, 500);
    }
  }, []);

  return (
    <>
      <HelmetDatoCms seo={seo} favicon={faviconMetaTags}>
        <html lang="en-GB" />
        {noIndex && <meta name="robots" content="noindex, follow" />}
        <script
          src={`https://www.google.com/recaptcha/api.js?render=${process.env.GATSBY_GOOGLE_RECAPTCHA_SITE_KEY}`}
          defer
        ></script>
      </HelmetDatoCms>
      <LocalBusinessSchema />
      <GlobalStyle isNavOpen={isNavOpen} isSearchOpen={isSearchOpen} />
      <Wrapper
        isOverlayActive={isOverlayActive}
        isCartOpen={isCartOpen}
        onClick={e => {
          if (e.target === e.currentTarget) {
            if (isCartOpen) {
              toggleCartOpen();
            } else if (isSearchOpen) {
              setSearchOpen(false);
            }
          }
        }}
      >
        <Header isNavOpen={isNavOpen} setNavOpen={setNavOpen} />
        {children}
        <Cart crossSellProducts={cartCrossSellProducts} />
        <Footer />
      </Wrapper>
    </>
  );
};

export default Layout;
